import {
  IDEA_CHANGE_INPUT,
  IDEA_SUBMIT_REQUESTING,
  IDEA_USER_GET_REQUESTING,
  IDEA_SUBMIT_SUCCESS,
  IDEA_USER_GET_SUCCESS,
  IDEA_USER_GET_ERROR,
  IDEA_SUBMIT_ERROR,
  IDEA_USER_SELECT,
  IDEA_SEE_SELECT,
  IDEA_USER_MODIFY_REQUESTING,
  IDEA_USER_MODIFY_SUCCESS,
  IDEA_USER_MODIFY_ERROR,
  IDEA_USER_DELETE_REQUESTING,
  IDEA_USER_DELETE_SUCCESS,
  IDEA_USER_DELETE_ERROR,
  IDEA_SELECTED_CHANGE_INPUT,
  IDEA_FOCUS_MENU,
  IDEA_GET_SELECTION_SUCCESS,
  IDEA_GET_SELECTION_ERROR,
  IDEA_RATE_REQUESTING,
  IDEA_RATE_ERROR,
  IDEA_RATE_SUCCESS,
  IDEA_RATE_MODIFY,
  IDEA_GET_ALL_SUCCESS,
  IDEA_GET_ALL_ERROR,
  IDEA_GET_ALL_REQUESTING,
  IDEA_CHANGE_STATUS_ERROR,
  IDEA_CHANGE_STATUS_REQUESTING,
  IDEA_CHANGE_STATUS_SUCCESS,
  IDEA_ALL_REMOVE_FILTER,
  IDEA_ALL_ADD_FILTER,
  IDEA_POST_COMMENT_REQUESTING,
  IDEA_POST_COMMENT_ERROR,
  IDEA_POST_COMMENT_SUCCESS,
  IDEA_LOAD_ALL_SUCCESS,
  IDEA_LOAD_ALL_ERROR,
  IDEA_LOAD_ALL_REQUESTING,
  IDEA_UPLOAD_PICTURE_SUCCESS,
  IDEA_UPLOAD_PICTURE_ERROR,
  IDEA_UPLOAD_PICTURE_REQUESTING,
  IDEA_SELECTED_UPLOAD_PICTURE_ERROR,
  IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING,
  IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS,
  IDEA_CHANGE,
  IDEA_NEW,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { IIdea } from "./types";

enum EIdeaFilter {
  Rejected = "rejected",
  Proposed = "proposed",
  Pending = "pending",
  Developing = "developing",
}

const INITIAL_STATE: IIdea = {
  title: "",
  text: "",
  author: {},
  error: "", // ""?
  allIdeasPage: 0,
  comment: "",
  picture: "",
  myIdeas: [],
  allIdeas: [],
  ideasToSelect: [],
  ideaToRate: {
    title: "",
    text: "",
    comments: [],
  },
  myIdeaSelected: {
    title: "",
    text: "",
    comments: [],
  },
  seeIdeaSelected: {
    title: "",
    text: "",
    comments: [],
    status: "",
  },
  lastVersion: {
    title: "",
    text: "",
    picture: "",
  },
  ideaSelected: {
    author: {},
    rating: 0,
    title: "",
    text: "",
    picture: "",
    comments: [],
    status: "",
  },
  rating: 0,
  commentRequesting: false,
  requesting: false,
  uploading: false,
  loading: false,
  focusedMenu: 0,
  newIdeas: 0,
  allIdeasFilters: [
    EIdeaFilter.Rejected,
    EIdeaFilter.Proposed,
    EIdeaFilter.Pending,
    EIdeaFilter.Developing,
  ],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IDEA_FOCUS_MENU:
      return {
        ...state,
        focusedMenu: action.payload,
      };

    case IDEA_SUBMIT_SUCCESS:
      return {
        ...state,
        requesting: false,
        myIdeas: [...state.myIdeas, action.payload],
        allIdeas: [action.payload, ...state.allIdeas],
        title: "",
        text: "",
        picture: "",
      };

    case IDEA_POST_COMMENT_SUCCESS: {
      const ideaSelected = { ...state.ideaSelected, comments: action.payload };
      return {
        ...state,
        requesting: false,
        comment: "",
        ideaSelected,
      };
    }

    case IDEA_SUBMIT_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case IDEA_POST_COMMENT_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case IDEA_SELECTED_UPLOAD_PICTURE_ERROR:
    case IDEA_UPLOAD_PICTURE_ERROR:
      return {
        ...state,
        uploading: false,
        error: action.payload,
      };

    case IDEA_USER_GET_ERROR:
    case IDEA_GET_ALL_ERROR:
    case IDEA_USER_DELETE_ERROR:
    case IDEA_USER_MODIFY_ERROR:
    case IDEA_GET_SELECTION_ERROR:
    case IDEA_CHANGE_STATUS_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case IDEA_RATE_ERROR:
      return {
        ...state,
        requesting: false,
        rating: 0,
      };

    case IDEA_SUBMIT_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case IDEA_CHANGE_INPUT:
      return {
        ...state,
        ...action.payload,
        // loading: false
      };

    case IDEA_SELECTED_CHANGE_INPUT: {
      const ideaSelected = { ...state.ideaSelected, ...action.payload };
      return {
        ...state,
        ideaSelected,
      };
    }

    case IDEA_USER_GET_REQUESTING:
      return {
        ...state,
        requesting: false,
      };

    case IDEA_USER_GET_SUCCESS:
      return {
        ...state,
        requesting: false,
        myIdeas: action.payload,
      };

    case IDEA_GET_SELECTION_SUCCESS:
      return {
        ...state,
        requesting: false,
        ideasToSelect: action.payload,
      };

    case IDEA_UPLOAD_PICTURE_SUCCESS:
      return {
        ...state,
        uploading: false,
        picture: action.payload,
      };

    case IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS:
      return {
        ...state,
        uploading: false,
        ideaSelected: { ...state.ideaSelected, picture: action.payload },
      };

    case IDEA_USER_SELECT:
    case IDEA_SEE_SELECT:
      return {
        ...state,
        lastVersion: action.payload,
        ideaSelected: action.payload,
      };

    case IDEA_LOAD_ALL_REQUESTING:
      return {
        ...state,
        loading: true,
      };

    case IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING:
    case IDEA_UPLOAD_PICTURE_REQUESTING:
      return {
        ...state,
        uploading: true,
      };

    case IDEA_POST_COMMENT_REQUESTING:
    case IDEA_CHANGE_STATUS_REQUESTING:
    case IDEA_USER_MODIFY_REQUESTING:
    case IDEA_USER_DELETE_REQUESTING:
    case IDEA_GET_ALL_REQUESTING:
    case IDEA_RATE_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case IDEA_CHANGE_STATUS_SUCCESS:
    case IDEA_USER_MODIFY_SUCCESS: {
      const { _id } = action.payload;
      const myIdeas = state.myIdeas.map(el => {
        if (el._id === _id) {
          return action.payload;
        }
        return el;
      });
      const allIdeas = state.allIdeas.map(el => {
        if (el._id === _id) {
          return action.payload;
        }
        return el;
      });
      return {
        ...state,
        requesting: false,
        lastVersion: action.payload,
        ideaSelected: action.payload,
        myIdeas,
        allIdeas,
      };
    }

    case IDEA_USER_DELETE_SUCCESS: {
      const { ideaId } = action.payload;
      const myIdeas = state.myIdeas.filter(el => el._id !== ideaId);
      const allIdeas = state.allIdeas.filter(el => el._id !== ideaId);
      return {
        ...state,
        ideaSelected: INITIAL_STATE.ideaSelected,
        requesting: false,
        myIdeas,
        allIdeas,
      };
    }

    case IDEA_RATE_SUCCESS: {
      const { ideaId } = action.payload;
      const ideasToSelect = state.ideasToSelect.filter(el => el._id !== ideaId);
      return {
        ...state,
        requesting: false,
        rating: 0,
        ideasToSelect,
      };
    }

    case IDEA_GET_ALL_SUCCESS: {
      return {
        ...state,
        requesting: false,
        allIdeasPage: 1,
        allIdeas: action.payload,
      };
    }

    case IDEA_LOAD_ALL_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case IDEA_LOAD_ALL_SUCCESS: {
      return {
        ...state,
        loading: false,
        allIdeasPage:
          action.payload.length > 0
            ? state.allIdeasPage + 1
            : state.allIdeasPage,
        allIdeas: [...state.allIdeas, ...action.payload],
      };
    }

    case IDEA_CHANGE_STATUS_SUCCESS: {
      const { _id } = action.payload;
      const allIdeas = state.allIdeas.map(el => {
        if (el._id === _id) {
          return action.payload;
        }
        return el;
      });
      return {
        ...state,
        requesting: false,
        allIdeas,
      };
    }

    case IDEA_ALL_REMOVE_FILTER: {
      const filter = action.payload;
      const allIdeasFilters = state.allIdeasFilters.filter(el => el !== filter);
      return {
        ...state,
        allIdeasFilters,
      };
    }

    case IDEA_ALL_ADD_FILTER: {
      const allIdeasFilters = state.allIdeasFilters
        ? [...state.allIdeasFilters, action.payload]
        : [action.payload];
      return {
        ...state,
        allIdeasFilters,
      };
    }

    case IDEA_RATE_MODIFY:
      return {
        ...state,
        rating: action.payload,
      };

    case IDEA_CHANGE: {
      const { _id } = action.payload;
      const myIdeas = state.myIdeas.map(el => {
        if (el._id === _id) {
          return action.payload;
        }
        return el;
      });

      const allIdeas = state.allIdeas.map(el => {
        if (el._id === _id) {
          return action.payload;
        }
        return el;
      });

      const ideaSelected =
        state.ideaSelected._id === _id ? action.payload : state.ideaSelected;

      return {
        ...state,
        myIdeas,
        allIdeas,
        ideaSelected,
      };
    }

    case IDEA_NEW: {
      return {
        ...state,
        newIdeas: state.newIdeas ? state.newIdeas + 1 : 1,
      };
    }

    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
